import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthConfigService, AuthFacade } from '@rx-applications/shared/auth/data-access';

export const SignupGuard: CanActivateFn = () => {
  const authConfig = inject(AuthConfigService).config;
  const authFacade = inject(AuthFacade);

  if (!authConfig?.selfSignup.enableSelfSignup) {
    authFacade.logoutAuthGuard();
    return false;
  }
  return true;
};
